import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(`#${id}`, { offset: -76, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

export function Reveal({ children, delay = 0, y = 28, className, ...rest }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function Crescent({ className = "" }) {
    return (
        <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
            <path
                d="M24 3a29 29 0 1 0 0 58c9.5-5.5 15-15.6 15-29S33.5 8.5 24 3Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function Eyebrow({ children, light = false }) {
    return (
        <p
            className={`font-mono text-[11px] md:text-xs uppercase tracking-[0.28em] ${
                light ? "text-brand-lime" : "text-brand-olive"
            }`}
        >
            {children}
        </p>
    );
}
